import ApiService from "./api.service";

export default function SubscriptionService() {}

SubscriptionService.getSubscriptions = () => {
  return ApiService.get("/subscriptions");
};

SubscriptionService.checkoutSubscriptions = (data) => {
  return ApiService.post("/subscriptions/checkout", data);
};

SubscriptionService.reattemptPayment = (data) => {
  return ApiService.post("/subscriptions/reattempt_payment", data);
};
